export class EndPointSensorLookup {
    constructor(
        public id: string,
        public name: string,
        public endPointId: string,
        public sensorId: string,
        public isEndPoint: boolean) { }
}
